import type { BackgroundColor } from "@sb1/ffe-grid-react/types/types";

type ColumnsRangeNumeric = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type ColumnsRange = ColumnsRangeNumeric | `${ColumnsRangeNumeric}`;
export interface GridColSize {
	cols: ColumnsRange;
	offset: ColumnsRange;
}
export type SizeModifier = ColumnsRange | GridColSize;

export type GridBackgroundColor = BackgroundColor | "subtle";

export const backgroundColorClass = (bgColor?: GridBackgroundColor) => {
	switch (bgColor) {
		case "primary":
			return "ppm-background__default";
		case "secondary":
			return "ppm-surface__secondary--default";
		case "subtle":
			return "ppm-background__subtle";
		case "tertiary":
			return "ppm-surface__tertiary--default";
		default:
			return "";
	}
};
